import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';

// DİL SİSTEMİ İÇİN GEREKLİ İMPORT
import { LanguageProvider } from './context/LanguageContext';

// Mevcut Bileşenler
import HomePage from './components/HomePage/HomePage';
import CookieBanner from './components/CookieBanner/CookieBanner';
import VideosPage from './components/VideosPage/VideosPage';
import AnnouncementsPage from './components/AnnouncementsPage/AnnouncementsPage';
import AboutPage from './components/AboutPage/AboutPage';
import ProductsPage from './components/ProductsPage/ProductsPage';

// Yeni Eklenen Dinamik Sayfalar
import CategoryDetail from './components/CategoryDetail/CategoryDetail'; 
import ProductDetail from './components/ProductDetail/ProductDetail'; 

// GLOBAL BİLEŞENLER
import Loader from './components/Loader/Loader'; 
import YemKatkilari from './components/YemKatkilari/YemKatkilari';
import ContactPage from './components/ContactPage/ContactPage';
import QuickContact from './components/QuickContact/QuickContact'; 
import CatalogSystem from './components/CatalogSystem/CatalogSystem';
import ProductShowcase from './components/ProductShowcase/ProductShowcase';

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde loader'ı aç
    setLoading(true);

    // Sayfa her değiştiğinde en yukarı çıkmasını sağlıyoruz
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, [location]); 

  return (
    /* KANKA: Tüm uygulamayı LanguageProvider ile sarmaladık */
    <LanguageProvider>
      {/* Global Loader Kontrolü */}
      {loading && <Loader />}

      <Routes>
        <Route path='/' element={<HomePage/>} />
        <Route path='/videolar' element={<VideosPage />} />
        <Route path='/duyurular' element={<AnnouncementsPage />} />
        <Route path='/urunlerimiz' element={<CatalogSystem />} />
        <Route path="/urun/:id" element={<ProductShowcase />} />
        <Route path='/iletisim' element={<ContactPage />} />

        {/* KATEGORİ VE ÜRÜN DETAYLARI */}
        <Route path='/urunlerimiz/:categorySlug' element={<CategoryDetail />} />
        <Route path='/yem-katkilari' element={<YemKatkilari />} />
        <Route path='/urun/:productId' element={<ProductDetail />} />
      </Routes>
      
      {/* SABİT BİLEŞENLER */}
      <QuickContact /> 
      <CookieBanner />
    </LanguageProvider>
  );
}

export default App;